import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=84a61d36&scoped=true&"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js&"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutFooter.vue?vue&type=style&index=0&id=84a61d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a61d36",
  null
  
)

export default component.exports